import { ArrowDropDown, ChevronRight } from '@sparkpost/matchbox-icons';
import classNames from 'classnames';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change, Field, formValueSelector } from 'redux-form';
import { ActionList, Box, Popover, TextField } from 'src/components/matchbox';
import { TranslatableText } from 'src/components/text';
import { useHibana } from 'src/context/HibanaContext';
// eslint-disable-next-line local/no-css-module-import
import styles from './FilterDropdown.module.scss';

// TYPES and SOURCES
type Option = {
  content: string;
  name: string;
};

interface FilterDropdownProps {
  change: (formName: string, namespaceName: string, value: $TODOFIXME) => void;
  displayValue: string;
  formName: string;
  id: string;
  label: string;
  name: string;
  namespace: string;
  onClose?: () => void;
  options: Option[];
  popoverClassName: string;
  values: Array<{ name: string }>;
}

/**
 * @deprecated use <MultiCheckboxDropdown /> instead
 */
export class FilterDropdown extends Component<FilterDropdownProps> {
  handleActionClick(e: MouseEvent, name: string) {
    const { formName, change, namespace, values } = this.props;
    const value = values && values[name] !== undefined ? values[name] : false;
    change(formName, `${namespace}.${name}`, !value);
    e.stopPropagation();
  }

  buildActions = () => {
    const { options, values } = this.props;
    const actions = options.map((option: $TODOFIXME) => ({
      ...option,
      onClick: (e: MouseEvent) => this.handleActionClick(e, option.name),
      selected: values && !!values[option.name]
    }));

    return actions;
  };

  countSelected() {
    let count = 0;

    // Disabling lint rule as this component is slated for removal
    // eslint-disable-next-line lodash/prefer-filter
    _.forEach(this.props.values, (value) => {
      if (value) {
        count++;
      }
    });
    return count;
  }

  renderCheckboxes() {
    const { options, namespace } = this.props;

    return options.map(({ name }: { name: $TODOFIXME }) => (
      <Field
        className={styles.hidden}
        key={name}
        type="checkbox"
        component="input"
        tabIndex={-1}
        id={`${namespace}.${name}`}
        data-id={`${namespace}.${name}`}
        name={`${namespace}.${name}`}
        parse={(value: $TODOFIXME) => !!value} // Prevents unchecked value from equaling ""
      />
    ));
  }

  onClose = () => {
    const { onClose = _.noop } = this.props;

    onClose(this.props.values);
  };

  render() {
    const { name, displayValue, popoverClassName, label, id } = this.props;
    const count = this.countSelected();
    const actions = this.buildActions();
    const prefix = count > 0 ? `(${count})` : null;

    return (
      <div>
        <Popover
          as="div"
          id={`filter-dropdown-popover-${id}`}
          className={classNames(styles.Popover, popoverClassName)}
          trigger={
            <TextField
              label={label}
              id={`filter-dropdown-${id}`}
              name={name}
              labelHidden
              prefix={prefix}
              value={displayValue}
              readOnly
              suffix={<FieldSuffix />}
            />
          }
          onClose={this.onClose}
        >
          <ActionList>
            {actions.map(({ content, ...action }: $TODOFIXME, i: number) => {
              return (
                <ActionList.Action key={`action-item-${i}`} {...action}>
                  <TranslatableText>{content}</TranslatableText>
                </ActionList.Action>
              );
            })}
          </ActionList>
        </Popover>
        {this.renderCheckboxes()}
      </div>
    );
  }
}

function FieldSuffix() {
  const [{ isHibanaEnabled }] = useHibana();

  if (isHibanaEnabled) {
    return (
      <Box as="span" color="blue.700">
        {/* eslint-disable-next-line */}
        <ChevronRight size={24} style={{ transform: 'rotate(90deg)' }} />
      </Box>
    );
  }

  return <ArrowDropDown />;
}

const mapStateToProps = (state: $TODOFIXME, { formName, namespace }: $TODOFIXME) => {
  const selector = formValueSelector(formName);
  return { values: selector(state, namespace) };
};

const mapDispatchToProps = { change };

export default connect(mapStateToProps, mapDispatchToProps)(FilterDropdown);
